import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';

import DocumentCell from '../../pages/ObjectDocs/DataTableComponents/Cells/DocCell';
import AddedByCell from '../../pages/ObjectDocs/DataTableComponents/Cells/AddedByCell';

import { MLButton } from 'components/Button/Button';
import { Document } from 'api/objectDocs/type';
import { Breakpoints } from 'hooks/Screen/useScreenSize';

interface UseGetDocumentListTableColumnsParams {
  onDeleteClick: (docID: number, docName: string) => void;
}

export const useGetDocumentListTableColumns = ({
  onDeleteClick,
}: UseGetDocumentListTableColumnsParams): TableColumn<Document>[] => {
  const { t } = useTranslation();

  const firstColToStart = [
    {
      when: (row: Document) => row.file === '-' || row.file !== '-',
      style: { justifyContent: 'start' },
    },
  ];

  return [
    {
      name: t('ObjectDocs.doc-table.doc-name'),
      selector: row => row.doc_name || '-',
      cell: row => <DocumentCell data={row} />,
      conditionalCellStyles: firstColToStart,
      grow: 2,
    },
    {
      name: t('ObjectDocs.doc-table.added-by'),
      selector: row => row.uploaded_by?.username || '-',
      cell: row => <AddedByCell data={row.uploaded_by} />,
      hide: Breakpoints.Tablet,
      grow: 2,
    },
    {
      name: t('ObjectDocs.doc-table.file-size'),
      selector: row => row.file_size,
      hide: Breakpoints.LargeDesktop,
    },
    {
      name: t('ObjectDocs.doc-table.upload-date'),
      selector: row => row.upload_date,
      hide: Breakpoints.Mobile,
    },
    {
      name: t('ObjectDocs.doc-table.action'),
      selector: row => row.is_archived,
      cell: row => {
        return row.is_archived ? (
          <MLButton disabled innerText={t('ObjectDocs.doc-table.archived')} />
        ) : (
          <MLButton onClick={() => onDeleteClick(row.id, row.doc_name)} innerText={t('ObjectDocs.doc-table.btn')} />
        );
      },
      hide: Breakpoints.Mobile,
    },
  ];
};
